import variables from '../styles/variables.module.scss';

export const muiBreakPoints = {
	values: {		
		xs: Number(variables.xs),
		sm: Number(variables.sm),
		md: Number(variables.md),
		lg: Number(variables.lg),
		xl: Number(variables.xl)
	}
};